import React, { useContext, useEffect } from "react";
import { Flex, Heading } from "@cisco/spaces-dash-lib-styleguide";
import "./custom-tnc-tab.scss";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { I18nContext } from "../../../contexts/i18nContext";

function CustomTncTab(props) {
  const i18n = useContext(I18nContext);
  const { app, setApp } = props;

  useEffect(() => {
    console.log("CustomTncTab Mount");

    return () => {
      console.log("CustomTncTab Destroy");
    };
  }, []);

  const onChangeCustomTerms = (event, editor) => {
    console.log("event", event, editor.getData());
    const newEditingNode = { ...app };
    if (newEditingNode.subscriptions[0] && newEditingNode.subscriptions[0].customTerms) {
      newEditingNode.subscriptions[0].customTerms.description = editor.getData();
    } else {
      newEditingNode.subscriptions[0].customTerms = { description: "" };
      newEditingNode.subscriptions[0].customTerms.description = editor.getData();
    }
    setApp(newEditingNode);
  };

  return (
    <Flex className="formMaxWidth pBottom40" direction="vertical" gap={8}>
      <Heading>{i18n.t("partner-dashboard-app.partner-apps.partner-apps-view.terms-and-conditions-text")}</Heading>
      <CKEditor
        editor={ClassicEditor}
        data={app.subscriptions[0].customTerms.description}
        onReady={(editor) => {
          // You can store the "editor" and use when it is needed.
          console.log("Editor is ready to use!", editor);
        }}
        onChange={onChangeCustomTerms}
      />
    </Flex>
  );
}

export default CustomTncTab;
